import { TableNode, TableCellNode, TableRowNode } from "@lexical/table";
import { TableWrapperNode } from "../nodes/TableWrapperNode";
import { AutoLinkNode, LinkNode } from "@lexical/link";

export const DEFAULT_CONFIG_TABLE = {
  nodes: [AutoLinkNode, LinkNode, TableNode, TableCellNode, TableRowNode, TableWrapperNode],
  theme: {
    paragraph: "paragraph-body1",
    text: { bold: "textBold", italic: "textItalic", placeholder: "placeholder" },
    tab: "tabNode",
    table: "table",
    tableAlignment: {
      center: "tableAlignmentCenter",
      right: "tableAlignmentRight",
    },
    tableCell: "tableCell",
    tableCellActionButton: "tableCellActionButton",
    tableCellActionButtonContainer: "tableCellActionButtonContainer",
    tableCellHeader: "tableCellHeader",
    tableCellResizer: "tableCellResizer",
    tableCellSelected: "tableCellSelected",
    tableRowStriping: "tableRowStriping",
    tableScrollableWrapper: "tableScrollableWrapper",
    tableSelected: "tableSelected",
    tableSelection: "tableSelection",
  },
};
